import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// Memoized currency formatter for BRL
const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

/**
 * Minimum date for expense filtering.
 * OpenFinance was released in Brazil in October 2025, so we only show
 * expense data from November 2025 onwards.
 */
export const EXPENSE_FILTER_MIN_DATE = new Date(2025, 10, 1); // November 1, 2025 (month is 0-indexed)

export const STANDARD_EXPENSE_CATEGORIES = [
  'essenciais',
  'lazer',
  'educacao',
  'saude',
  'transporte',
  'investimento',
  'outros',
];

export function formatCurrency(value: number): string {
  return brlFormatter.format(value);
}

export function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getMonthYearLabel(date: Date): string {
  return format(date, "MMMM, yyyy", { locale: ptBR });
}

// Helper to parse month from URL param (format: YYYY-MM)
export function parseMonthParam(param: string | null): Date {
  if (!param) return new Date();
  const [year, month] = param.split('-').map(Number);
  if (!year || !month || month < 1 || month > 12) return new Date();
  return new Date(year, month - 1, 1);
}

// Helper to format date to URL param (format: YYYY-MM)
export function formatMonthParam(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}
